import { Link } from 'react-router-dom';
import { EditableText } from '@/core/EditableText.atom';
import { AUTO_WIDTH_OFFSET } from '@/main/app.constants';
import { getWorksheetLink } from '@/main/routing.utilities';
import { useUpdateTreeName } from '@/treeBuilder/useUpdateTreeName.hook';

export interface TreeBuilderHeaderProps {
  tableId: string;
  name: string;
  tableScopedTo?: string;
  workbookId?: string;
  workbookName?: string;
  canWrite?: boolean;
}

export const TreeBuilderHeader = ({
  tableId,
  name,
  tableScopedTo,
  workbookId,
  workbookName,
  canWrite = true,
}: TreeBuilderHeaderProps) => {
  const { updateTreeName } = useUpdateTreeName();

  return (
    <div className="tw:flex tw:flex-col tw:items-center tw:justify-center">
      {workbookId && (workbookId === tableScopedTo || !tableId) && workbookName && (
        <div className="flexNoGrow flexNoOverflow flexColumnContainer flexCenter">
          <span className="mt0 mb2 fs11">
            <ul className="unstyled-list text-not-bold flexColumnContainer headerBreadcrumbs folderBreadcrumbs mt0 mb0 flexNoGrow">
              <li className="ml2" key="crumbId_workbook">
                <Link to={getWorksheetLink(workbookId)}>{workbookName}</Link>
              </li>
            </ul>
          </span>
        </div>
      )}
      <EditableText
        onUpdate={(newName) => updateTreeName(tableId, newName)}
        value={name}
        textClasses="fs14 tw:min-w-5"
        testId="headerItemTableName"
        id="headerItemTableName"
        offsetWidth={AUTO_WIDTH_OFFSET}
        oneLineText={true}
        allowEditing={canWrite}
      />
    </div>
  );
};
